import React from "react";
import { Route } from "react-router-dom";
import { changeDimensionsApp
} from '../../action/actionCreators';
import Home from "../../components/Home";
import Proveedores from "../../components/NextGroup/MantenimientoProveedores";
import Documentos from "../../components/NextGroup/MantenimientoDocumentacion"
import Noticias from "../../components/NextGroup/Noticias";
import Referencias from "../../components/NextGroup/MantenimientoGrupoMontaje"
import Tarifas from "../../components/NextGroup/MantenimientoActualizaciones"
import MisConsumos from "../NextGroup/MantenimientoConsumos"
import LicenciasSertec from "../../components/Sertec/LicenciasSertec"
import LicenciasFacturacionSertec from "../../components/Sertec/LicenciasFacturacion";
import EstadisticasMatriculasSertec from "../../components/Sertec/EstadisticasMatriculas";
import LicenciasNextAssist from "../../components/NextAssist/ContainerLicenciaNextAssist";
import LicenciasFacturacionNextAssist from "../../components/NextAssist/FacturacionAssist";
import SustitucionAlmacenes from "../Sertec/SustitucionAlmacenes";
import ReglasFiltroGrupoMontaje from "../Sertec/ReglasFiltroGrupoMontaje";
import ReglaFiltroNeumatico from "../Sertec/ReglaFiltroNeumatico";
import LicenciasInfoTechnic from "../../components/NextInfotechnic/ContainerLicenciasNextInfo";
import  PageMarketing from "../Sertec/PageMarketing";

import { ContainerApp } from "./ContainerApp";
import { MenuApp } from "./MenuApp";
import store from '../../store'
import Mensajeria from "../Sertec/Mensajeria";
import PageMatricula from "../NextAssist/PageMatricula";

export const Main = () => {
    const ANCHO_MENU_GRANDE = 220
    const ANCHO_MENU_PQ = 70
    const [TAM_MENU, setTAM_MENU] = React.useState(ANCHO_MENU_GRANDE)


    const handleResize = () => {
        store.dispatch(changeDimensionsApp(window.innerWidth, window.innerHeight));
    }

    React.useEffect(() => {
        handleResize()
        window.addEventListener('resize', handleResize)
    }, [])

    return <>
        <div className="layaoutApp">
            <MenuApp
                ANCHO_MENU_GRANDE={ANCHO_MENU_GRANDE}
                VARIABLES={() => [TAM_MENU, setTAM_MENU]}
            >
            </MenuApp>



            <ContainerApp
                ANCHO_MENU_GRANDE={ANCHO_MENU_GRANDE}
                ANCHO_MENU_PQ={ANCHO_MENU_PQ}
                VARIABLES={() => [TAM_MENU, setTAM_MENU]}
                COMPONENT={
                    <>
                        <Route exact path="/home" component={Home} />
                        <Route exact path="/proveedores" component={Proveedores} />
                        <Route exact path="/documentos" component={Documentos} />
                        <Route exact path="/noticias" component={Noticias} />
                        <Route exact path="/referencias" component={Referencias} />
                        <Route exact path="/tarifas" component={Tarifas} />
                        <Route exact path="/licenciassertec" component={LicenciasSertec} />
                        <Route exact path="/facturacionsertec" component={LicenciasFacturacionSertec} />
                        <Route exact path="/matriculassertec" component={EstadisticasMatriculasSertec} />
                        <Route exact path="/licenciasnextassist" component={LicenciasNextAssist} />
                        <Route exact path="/facturacionnextassist" component={LicenciasFacturacionNextAssist} />
                        <Route exact path="/sustitucionAlmacenes" component={SustitucionAlmacenes} />
                        <Route exact path="/filtrogrupomontaje" component={ReglasFiltroGrupoMontaje} />
                        <Route exact path="/filtroneumatico" component={ReglaFiltroNeumatico} />
                        <Route exact path="/misconsumos" component={MisConsumos} />
                        <Route exact path="/licenciasinfotechnic" component={LicenciasInfoTechnic} />
                        <Route exact path="/marketing" component={PageMarketing} />
                        <Route exact path="/mensajeria" component={Mensajeria} />
                        <Route exact path="/matriculasassist" component={PageMatricula} />
                    </>
                }
            >
            </ContainerApp>
        </div>
    </>;
};